module.exports = __webpack_public_path__ + "images/img_IP_2-4829ec3ee9.png";